// Reception reference type
enum ReferenceType {
  ORDER = "order",
  PRODUCT = "item",
}

export default ReferenceType;
